import { BrowserRouter, Route, Switch } from "react-router-dom";

import AppProvider from "./components/AppProvider/AppProvider";
import Dashboard from "./containers/Dashboard";
import React from "react";
import registerServiceWorker from "./registerServiceWorker";
import { render } from "react-dom";
import { AuthProvider } from "./context/AuthContext";
import Login from "./pages/Login"
import PrivateRoute from "./containers/PrivateRoute";

render(
  <AppProvider>
    <AuthProvider>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Switch>
        <Route path="/login" exact component={Login} />
        <PrivateRoute path="/" component={Dashboard} />
        </Switch>
      </BrowserRouter>
    </AuthProvider>
  </AppProvider>,
  document.getElementById("root")
);

registerServiceWorker();
